<template>
	<div>
		<v-card class="mx-auto" max-width="386" tile>
			<v-list>
				<v-list-item>
					<v-spacer></v-spacer>
					<v-badge
						bordered
						top
						icon="mdi-pencil"
						overlap
						color="secondary"
						offset-x="23"
						offset-y="23"
					>
						<v-icon
							slot="badge"
							style="z-index: 1"
							@click="$refs.inputUpload.click()"
						>
							mdi-pencil
						</v-icon>
						<input
							v-show="false"
							ref="inputUpload"
							type="file"
							accept="image/*"
							@change="upload"
							@input="item.image = $event.target.files[0]"
						/>

						<v-avatar size="100">
							<v-img
								:src="
									customer_image
										? customer_image
										: 'https://www.psi.org.kh/wp-content/uploads/2019/01/profile-icon-300x300.png'
								"
								width="100px"
								height="100px"
							></v-img>
						</v-avatar>
					</v-badge>
					<v-spacer></v-spacer>
				</v-list-item>

				<v-list-item class="text-center">
					<v-list-item-content>
						<v-list-item-subtitle>
							{{ $t("label.hello") }}
						</v-list-item-subtitle>
						<v-list-item-title class="text-h6">
							{{ customer }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-divider></v-divider>
			<v-list>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('profile.index')"
					:input-value="$route().current('profile.index')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-account-circle</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.my_information")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('reservation.reservations.index')"
					:input-value="$route().current('reservation.*')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-calendar</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.my_reservations")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>

				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('shop.orders.index')"
					:input-value="$route().current('shop.*')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-cart</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.my_orders")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>

				<v-list-item class="ml-4">
					<v-list-item-icon>
						<v-icon>mdi-bell-ring</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{
							$t("title.notification")
						}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-switch
							v-model="notificaiton"
							inset
							color="blue"
						></v-switch>
					</v-list-item-action>
				</v-list-item>

				<v-divider></v-divider>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('shop.addresses.index')"
					:input-value="$route().current('shop.addresses.index')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-google-maps</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.my_delivery_addresses")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('language.index')"
					:input-value="$route().current('language.index')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-earth</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.language")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('about')"
					:input-value="$route().current('about')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-exclamation</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.about_thalias_group")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>
				<Link
					as="v-list-item"
					link
					ripple
					:href="$route('contact')"
					:input-value="$route().current('contact')"
				>
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-account-box-multiple</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("title.contact")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</Link>
				<v-divider></v-divider>
				<v-list-item Link ripple @click="logout()">
					<v-list-item>
						<v-list-item-icon>
							<v-icon>mdi-logout</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{
								$t("label.logout")
							}}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	props: ["customer", "customer_image"],
	components: {
		Link,
	},
	data() {
		return {
			notificaiton: true,
			item: this.$inertia.form({
				image: null,
			}),
		};
	},
	methods: {
		async upload(e) {
			this.item.post(this.$route("profile.update.image"), {
				forceFormData: true,
			});
		},

		logout() {
			this.$inertia.delete("/auth/logout");
		},
	},
};
</script>